import { NodeConnectionNames } from './../../dto/NodeConnection';
import { NodeConnectionUi } from 'classes/NodeConnectionUi';
import { FlowResultDto } from 'dto/FlowResultDto';
import { Observable } from 'rxjs/Rx';
import { ApiService } from 'services/api.service';
import { NodeUi } from 'classes/NodeUi';
import { Component, AfterViewChecked, ElementRef, EventEmitter, Output } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';

import { FlowService } from 'services/flow.service';
import { BaseNodeConfig } from 'dto/NodeConfig';
import { FlowConfig } from 'dto/FlowConfig';
import { FlowUi } from 'classes/FlowUi';

@Component({
    selector: 'fetchdata',
    templateUrl: './fetchdata.component.html',
    styleUrls: ['./fetchdata.component.css']
})
export class FetchDataComponent {

    @Output() flowIdChange:EventEmitter<string> = new EventEmitter();
    // publics
    public flowId: string;
    public flow: FlowUi;
    public loading: boolean;

    constructor(http: Http, private api:ApiService, private route: ActivatedRoute, private router: Router, private flowService:FlowService) {
        this.loading = true;

        // subscribe to flowID changes in the querystring is, if so then reload the component and its data.
        route.paramMap.subscribe( map => 
        {
            if (map.get('id') == '') {

                // instantiate a new flow with a single root node
                let newFlow = new FlowConfig();
                this.api.loadExpressionTemplates().subscribe(result => {
                    let newNode = new BaseNodeConfig(this.api.getExpressionTemplate("XPR"));
                    newNode.Name = "My first Node";
                    newFlow.Nodes = [newNode];
                    api.saveFlowConfig(newFlow).subscribe(result => this.router.navigate(['/fetch-data',result]))
                });
            }
            else
            {
                this.getFlow(map.get('id'));
            }
        });
    }
    
    private getFlow(flowId: string): void {
            this.flowId = flowId;
            Observable.forkJoin([this.api.getFlow(this.flowId),
                                 this.api.getSubflowOutputs(this.flowId),
                                 this.api.loadExpressionTemplates()]
            ).subscribe(
                result => {
                    let flow = result[0];
                    // make a ui version of the returned dto.
                    if (flow != null)
                    {
                        this.flow = new FlowUi(this.api, flow);
                        this.flow.SubFlowOutputs = result[1];
                        this.flow.Compile();
                        this.flow.ReRender();
                    }
                    this.flowService.FlowChange.emit(flowId);
                },
                error => console.error('Error: ' + error),
                () => this.loading = false
            );
    }

    dropOnTrash(event):void{
        (<NodeUi>event.dragData).Flow.deleteNodeASync(event.dragData,true).subscribe(()=>{});
    }
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/fetchdata/fetchdata.component.ts